import isArray from 'lodash/isArray';
import capitalize from 'lodash/capitalize';
import { ApiError } from '~/api/generated';

export function useApiUtils() {
  const { t, te } = useI18n();
  const { error } = useCustomToasts();

  const extractApiError = (_error: ApiError, defaultMessage: string) => {
    if (isArray(_error?.body?.errors)) {
      _error.body.errors.forEach((e: { attr: string; code: string; detail: string }) => {
        if (e.attr) {
          error(`${capitalize(e.attr)}: ${e.detail}`);
          return;
        }
        const codeKey = `api.errors.${e.code}`;
        error(te(codeKey) ? t(codeKey) : e.detail || t(defaultMessage));
      });

      return;
    }

    error(_error.body?.detail || _error.body?.message || _error.body?.error || t(defaultMessage));
  };

  return { extractApiError };
}
